var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-view-wrapper"},[_c('slide-bar'),_c('div',{staticClass:"main-view-content"},[_c('header-nav'),_c('div',{staticClass:"main-view-router-view"},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }